class Player
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Player
	// ---------------------------------------------------------------------------------------------------------

  constructor(player)
  {
    //プレイヤー参照
    var $player = player

    //ボタン配置
    $player.append('<div class="video-player__play-btn"><div class="video-player__play-icon"></div></div>')

    //ボタン
    var $btn = $player.find('.video-player__play-btn')

    //ビデオ
    var $video = $player.find('video')

    //ボタンクリック
    $btn.on('click', function(){
      if($(this).hasClass('playActive'))
      {
        $video.get(0).pause()
      }
      else
      {
        $video.get(0).play()
      }
    });

    //再生
    $video.on('playing', function(){
      $btn.addClass('playActive');
      $video.attr('controls', '');
    });

    //終了
    $video.on('ended', function(){
      $btn.removeClass('playActive');
      $video.removeAttr('controls');
    });
  }
}

export default Player
